import {
  AuthAPI,
  GlobalAuthState,
  MP_REGISTER_VERIFIED_RESET,
  MP_REGISTER_VERIFIED_USER_CREATE_ERROR,
  MP_REGISTER_VERIFIED_USER_CREATE_PENDING,
  MP_REGISTER_VERIFIED_USER_CREATE_SUCCESS,
  MP_REGISTER_VERIFIED_USER_SEND_CODE_ERROR,
  MP_REGISTER_VERIFIED_USER_SEND_CODE_PENDING,
  MP_REGISTER_VERIFIED_USER_SEND_CODE_SUCCESS,
  MP_REGISTER_VERIFIED_USER_SET_LOGIN_ERROR,
  MP_REGISTER_VERIFIED_USER_SET_LOGIN_PENDING,
  MP_REGISTER_VERIFIED_USER_SET_LOGIN_SUCCESS,
  RegisterVerifedUserCreateQuery,
  RegisterVerifedUserSendCodeQuery,
  RegisterVerifedUserSetLoginQuery,
  RegisterVerifiedUserCreateActions,
  RegisterVerifiedUserCreateResult,
  RegisterVerifiedUserError,
  RegisterVerifiedUserSendCodeActions,
  RegisterVerifiedUserSendCodeResult,
  RegisterVerifiedUserSetLoginActions,
  RegisterVerifiedUserSetLoginResult,
} from '@cibo/core'
import { AxiosResponse } from 'axios'
import { Action } from 'redux'
import { ThunkAction } from 'redux-thunk'

import { refreshUserInfo } from './UserInfo'

const registerVerifiedUserSendCodePending = (): RegisterVerifiedUserSendCodeActions => ({
  type: MP_REGISTER_VERIFIED_USER_SEND_CODE_PENDING,
})
export const registerVerifiedUserSendCodeSuccess = (
  results: AxiosResponse<RegisterVerifiedUserSendCodeResult>
): RegisterVerifiedUserSendCodeActions => ({
  type: MP_REGISTER_VERIFIED_USER_SEND_CODE_SUCCESS,
  results,
})
const registerVerifiedUserSendCodeError = (
  error: RegisterVerifiedUserError
): RegisterVerifiedUserSendCodeActions => ({
  type: MP_REGISTER_VERIFIED_USER_SEND_CODE_ERROR,
  error,
})

export const registerVerifyEmail =
  (query: RegisterVerifedUserSendCodeQuery): ThunkAction<void, any, null, Action<string>> =>
  async dispatch => {
    dispatch(registerVerifiedUserSendCodePending())
    try {
      const results = await AuthAPI.registerVerifedUserSendCode(query)
      dispatch(registerVerifiedUserSendCodeSuccess(results))
    } catch ({ response: { data } = { data: {} } }: any) {
      dispatch(registerVerifiedUserSendCodeError(data as RegisterVerifiedUserError))
    }
  }

const registerVerifiedUserCreatePending = (
  query: RegisterVerifedUserCreateQuery
): RegisterVerifiedUserCreateActions => ({
  type: MP_REGISTER_VERIFIED_USER_CREATE_PENDING,
  query,
})
const registerVerifiedUserCreateSuccess = (
  results: AxiosResponse<RegisterVerifiedUserCreateResult>
): RegisterVerifiedUserCreateActions => ({
  type: MP_REGISTER_VERIFIED_USER_CREATE_SUCCESS,
  results,
})
const registerVerifiedUserCreateError = (
  error: RegisterVerifiedUserError
): RegisterVerifiedUserCreateActions => ({
  type: MP_REGISTER_VERIFIED_USER_CREATE_ERROR,
  error,
})

export const createVerifiedUser =
  (query: RegisterVerifedUserCreateQuery): ThunkAction<void, any, null, Action<string>> =>
  async dispatch => {
    dispatch(registerVerifiedUserCreatePending(query))
    try {
      const results = await AuthAPI.registerVerifedUserCreate(query)

      dispatch(registerVerifiedUserCreateSuccess(results))
    } catch ({ response: { data } = { data: {} } }: any) {
      dispatch(registerVerifiedUserCreateError(data as RegisterVerifiedUserError))
    }
  }

const registerVerifiedUserSetLoginPending = (
  query: RegisterVerifedUserSetLoginQuery
): RegisterVerifiedUserSetLoginActions => ({
  type: MP_REGISTER_VERIFIED_USER_SET_LOGIN_PENDING,
  query,
})
const registerVerifiedUserSetLoginSuccess = (
  results: AxiosResponse<RegisterVerifiedUserSetLoginResult>
): RegisterVerifiedUserSetLoginActions => ({
  type: MP_REGISTER_VERIFIED_USER_SET_LOGIN_SUCCESS,
  results,
})
const registerVerifiedUserSetLoginError = (
  error: RegisterVerifiedUserError
): RegisterVerifiedUserSetLoginActions => ({
  type: MP_REGISTER_VERIFIED_USER_SET_LOGIN_ERROR,
  error,
})

export const finalizeVerifiedUserRegistrationAndLogin =
  (query: RegisterVerifedUserSetLoginQuery): ThunkAction<void, any, null, Action<string>> =>
  async dispatch => {
    dispatch(registerVerifiedUserSetLoginPending(query))
    try {
      const results = await AuthAPI.registerVerifedUserUpdateLogin(query)
      const {
        data: { userJwt },
      } = results
      GlobalAuthState.setAuthStateValid(userJwt)
      const fullUser = await AuthAPI.userInfo()

      dispatch(registerVerifiedUserSetLoginSuccess({ ...fullUser, ...results }))
      dispatch(refreshUserInfo())
    } catch ({ response: { data } = { data: {} } }: any) {
      dispatch(registerVerifiedUserSetLoginError(data as RegisterVerifiedUserError))
    }
  }

export const resetVerifiedUserFlow =
  (): ThunkAction<void, any, null, Action<string>> => async dispatch => {
    dispatch({ type: MP_REGISTER_VERIFIED_RESET })
  }
